import styled from 'styled-components/macro';

import { rem } from '@blueprint/ui';
import { Flex } from 'rebass/styled-components';

import { LabelPill } from 'components/blueprint';
import { colors } from 'themes';

export const ActionLabelPill = styled(LabelPill)`
  && {
    background-color: ${colors.white};
    padding: ${rem(6)} ${rem(10)};
    margin-bottom: ${rem(8)};
    text-decoration: none;
  }
`;

export const ActionPillWrapper = ({ children }) => {
  return (
    <Flex
      sx={{
        flexBasis: 'fit-content',
        flexWrap: 'wrap',
        marginTop: rem(6),
      }}
    >
      {children}
    </Flex>
  );
};
